// Script anti-flash injecté dans le <head>, exécuté AVANT le premier paint.
//
// Il pose sur <html> les préférences d'affichage lues dans le stockage local :
//   · `data-theme` — thème choisi ; absent en « auto », où le CSS `prefers-color-scheme`
//     décide seul, donc aucun flash de thème incorrect.
//
// Table déclarative : ajouter une préférence d'affichage ne demande qu'une entrée dans
// `KEYS` et la règle CSS correspondante — jamais de code dans ce script bloquant.

export const THEME_STORAGE_KEY = 'rmbr-theme';

/** Clé de stockage → attribut posé, et valeurs acceptées. Toute autre valeur est ignorée. */
const KEYS: Array<{ key: string; attr: string; allowed: string[] }> = [
  { key: THEME_STORAGE_KEY, attr: 'data-theme', allowed: ['light', 'dark'] },
];

export const themeInitScript = `(function(){try{var d=document.documentElement,k=${JSON.stringify(
  KEYS,
)};for(var i=0;i<k.length;i++){var v=localStorage.getItem(k[i].key);if(k[i].allowed.indexOf(v)>=0){d.setAttribute(k[i].attr,v);}else{d.removeAttribute(k[i].attr);}}}catch(e){}})();`;
